<template>
  <div>
    <el-dialog title="题目设置" :visible.sync="dialogVisibleFrom" width="50%" @close="closeDialog" center
      class="questionDialog" :close-on-click-modal="false">
      <el-form :model="questionForm" ref="questionForm" label-width="120px" :rules="rules"
        :validate-on-rule-change="false">
        <el-form-item label="题目类型：">
          <el-radio-group v-model="questionForm.type" @change="resetForm(questionForm)">
            <el-radio :label="1">单选题</el-radio>
            <el-radio :label="2">多选题</el-radio>
            <el-radio :label="3">填空题</el-radio>
            <el-radio :label="4">图片选择题</el-radio>
            <el-radio :label="5">图片上传题</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="题目名称：" required>
          <el-input v-model="questionForm.title" maxlength="50" show-word-limit style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="是否必填：">
          <el-radio-group v-model="questionForm.isMust">
            <el-radio :label="1">必填</el-radio>
            <el-radio :label="0">非必填</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 设置文字选项 -->
        <div v-if="questionForm.type === 1 || questionForm.type ===2">
          <el-form-item label="选 项" v-for="(option, index) in questionForm.options" :key="option.key">
            <span v-if="index == 0">A</span>
            <span v-if="index == 1">B</span>
            <span v-if="index == 2">C</span>
            <span v-if="index == 3">D</span>
            <span v-if="index == 4">E</span>
            <span v-if="index == 5">F</span>
            <template>
              <el-input v-model="option.description" maxlength="10" style="margin-left:20px" show-word-limit></el-input>
              <span class="delectOption" @click.prevent="removeOption(index)">删除</span>
            </template>
            <!-- 单选题添加选中输入 -->
            <div v-if="questionForm.type === 1" style="margin-left: 30px;margin-top: 12px">
              <span>选中是否需输入信息</span>
              <el-select size="small" v-model="option.isInputText" style="width: 132px;margin:0px 10px 0px 20px;" @change="option.inputTextLimit = ''">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
              <template v-if="option.isInputText == 1">
                <span>字数限制: </span>
                不少于<el-input v-model.number="option.inputTextLimit" placeholder="输入整数" @input="option.inputTextLimit = getNumberData($event, 0,1,999)"
                  style=" width: 80px;margin: 0 6px;"></el-input>个字
              </template>
            </div>
          </el-form-item>
        </div>
        <!-- 添加文字选项按钮 -->
        <el-form-item v-if="questionForm.type === 1 || questionForm.type ===2">
          <div @click="addOption" class="addBtn">
            新增选项（{{ questionForm.options.length }}/6）
          </div>
        </el-form-item>
        <!-- 设置图片选项 -->
        <div v-if="questionForm.type === 4">
          <el-form-item label="选 项 " v-for="(imgOption, index) in questionForm.options" :key="imgOption.key">
            <div class="uploadBox" v-loading="imgOption.loading">
              <span v-if="index == 0">A</span>
              <span v-if="index == 1">B</span>
              <span v-if="index == 2">C</span>
              <span v-if="index == 3">D</span>
              <span v-if="index == 4">E</span>
              <span v-if="index == 5">F</span>
              <el-upload class="avatar-uploader" action="" multiple :limit="1"
                :before-upload="beforeUpload1.bind(null,{'index':index,'data':imgOption})" accept=".jpg,.png"
                style="width:80px;margin-left:20px;">
                <img v-if="imgOption.picUrl" :src="imgOption.picUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div v-if="imgOption.description" class="uploadBox-desc">{{ imgOption.description }}</div>
              <div class="uploadBox-desc" v-else>
                <p>建议上传尺寸：200px*200px</p>
                <p>图片大小：2M以内</p>
                <p>格式：jpg、png</p>
              </div>
              <span class="delectOption" @click.prevent="removeOption(index)">删除</span>
            </div>
          </el-form-item>
        </div>
        <!-- 添加图片选项按钮 -->
        <el-form-item v-if="questionForm.type === 4">
          <div @click="addOption()" class="addBtn">
            新增选项（{{ questionForm.options.length }}/6）
          </div>
        </el-form-item>
        <!-- 字数限制 填空题显示 -->
        <div v-if="questionForm.type === 3">
          <el-form-item label="字数限制：">
            不少于<el-input v-model.number="questionForm.textLimit"
              @input="questionForm.textLimit = getNumberData($event, 0, 1, 999)"
              style=" width: 80px;margin: 0 15px;"></el-input>个字
          </el-form-item>
        </div>
        <!-- 上传张数 图片上传显示 -->
        <div v-if="questionForm.type === 5">
          <el-form-item label="上传张数：">
            不少于<el-input v-model.number="questionForm.picLimit" placeholder="1"
              @input="questionForm.picLimit = getNumberData($event, 0,1,5)"
              style=" width: 80px;margin: 0 15px;"></el-input>张,最多5张
          </el-form-item>
        </div>
      </el-form>
      <!-- 底部 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveQuestion()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploadImage } from "@/api/sellerImageController";
export default {
name: "questionItem",
components: {
},
props: {
  isShow: {
    type: Boolean,
    default: false,
  },
  queForm:{
    type:Object,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
},
computed: {

},
data() {
    return {
      loading:false,
      dialogVisibleFrom: this.isShow,
      dialogVisibleImg: false,
      questionForm:{ //问卷默认内容
        type: 1,//默认单选1
        title:"",
        isMust:1,//默认必填
        options: [ //选项默认3个
          // {description: '',picUrl:'',loading:false},
          // {description: '',picUrl:'',loading:false},
          // {description: '',picUrl:'',loading:false},
          {description: '',picUrl:'',loading:false, isInputText:0,inputTextLimit:''},
          {description: '',picUrl:'',loading:false, isInputText:0,inputTextLimit:''},
          {description: '',picUrl:'',loading:false, isInputText:0,inputTextLimit:''},
        ],
        textLimit:'',//填空题字数限制
        picLimit:1,//图片上传张数限制
      },
      isLoading:false,
      rules: {
          title: [
            { required: true, message: '请输入题目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择一个题目类型', trigger: 'change' }
          ],
          isMust: [
            { required: true, message: '请选择是否必填', trigger: 'change' }
          ]
      },
      imageUrl1:"",
    };
},
mounted() {
  if(this.isEdit){
    // this.questionForm = {...this.queForm,options:this.queForm.options}
    this.questionForm = JSON.parse(JSON.stringify(this.queForm))
  }
},
methods: {
    //切换重置表
    resetForm(formName) {
        this.$refs.questionForm.clearValidate();
        //切换清空内容
        if(this.isEdit &&  this.questionForm.type == this.queForm.type){
          this.questionForm.textLimit= this.queForm.textLimit
          this.questionForm.options= this.queForm.options
          this.questionForm.picLimit= this.queForm.picLimit
        }else{
          // this.questionForm.title = ""
          this.questionForm.textLimit=''
          this.questionForm.isMust = 1
          this.questionForm.options = [
            { description: '', picUrl: '', loading: false, isInputText: 0, inputTextLimit: '' },
            { description: '', picUrl: '', loading: false, isInputText: 0, inputTextLimit: '' },
            { description: '', picUrl: '', loading: false, isInputText: 0, inputTextLimit: '' },
          ]
        }
       
      },
    //输入限制
    // getNumberData1(e,type){
    //   console.log("e",e)
    //   if(type === 1){
    //     if( e > 999 ){
    //       return 999
    //     }else{
    //       return e
    //     }
    //   }else if(type === 2){
    //     if( e > 5 ){
    //       return 5
    //     }else{
    //       return e
    //     }
    //   }else{
    //     return e
    //   }
    // },
    //上传图片
    beforeUpload1(obj,file) {
      let _this = this;
      // if(this.isLoading){
      //   this.$message.warning("图片正在上传请勿操作");
      //   return
      // }
      _this.isLoading = true
      obj.data.loading =true
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size < 2097152;
      if (!(isJPG || isPNG || isJPEG)) {
        this.$message.error("上传图片只能是JPG和PNG格式!");
        obj.data.loading =false
        _this.isLoading = false
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        obj.data.loading = false
        _this.isLoading = false
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      uploadImage(forms).then((res) => {
        console.log("上传图片，res")
        this.questionForm.options[obj.index].picUrl=res.data
        this.questionForm.options[obj.index].description=file.name
        obj.data.loading =false
        _this.isLoading = false
      });
      return !(isJPG || isPNG || isJPEG) && isLt2M;
    },
    //添加图片选项
    addOption() {
        if (this.questionForm.options.length === 6) {
          this.$message.warning("最多可设置6个选项");
          return;
        }
        this.questionForm.options.push({
          description:'',
          picUrl: '',
          loading:false,
          key: Date.now(),
          isInputText:0, //添加是否需要输入信息
          inputTextLimit: ''
        });

    },
  //删除图片选项
  removeOption(index) {
      if(this.isLoading){
        this.$message.warning("图片正在上传请勿操作");
        return
      }
      if (this.questionForm.options.length === 2) {
        this.$message.warning("最少需设置2个选项");
        return;
      }
      if (index !== -1) {
        this.questionForm.options.splice(index, 1)
      }
  },

  //  保存题目
  saveQuestion(){
    console.log("this",this.questionForm)

     // 判断题目填写
     if(!this.questionForm.title){
      this.$message.warning("请填写题目名称");
      return 
    }
    //单选题、多选题
    if( this.questionForm.type === 1 || this.questionForm.type === 2){
      let isOk = false;
      let msgType = 1;
      this.questionForm.options.forEach(item=>{
        console.log("题目选项",item)
        if(!item.description){
          isOk = true;
          msgType = 1;
        }
        if(this.questionForm.type === 1 && item.isInputText==1 && !item.inputTextLimit) {
          isOk = true;
          msgType = 2;
        }
      })
      if(isOk){
        this.$message.warning(msgType==2 ? '请设置字数限制':'请正确设置题目选项');
        return 
      }
    }
    //填空题
    if(this.questionForm.type === 3){
      let num = Number(this.questionForm.textLimit)
      console.log("num",num)
      if(!num){
        this.$message.warning("请设置字数限制");
        return 
      }
      if(num && num < 1){
        this.$message.warning("设置字数不能少于1");
        return 
      }
    }
    //图片选择题
    if( this.questionForm.type === 4){
      let isOk = false
      this.questionForm.options.forEach(item=>{
        console.log("题目选项",item)
        if(!item.picUrl){
          isOk = true
        }
      })
      if(isOk){
        this.$message.warning("请正确设置题目选项");
        return 
      }
    }
    //图片上传题
    if( this.questionForm.type === 5 ){
      let num = Number(this.questionForm.picLimit)
      console.log("num",num)
      if(num > 5){
        this.$message.warning("设置上传张数不得超过5张");
        return 
      }else if(num < 1){
        this.$message.warning("设置上传张数不得少于1张");
        return 
      }
    }

    let _form = this.questionForm
    console.log('form>>>',_form)
    this.$emit("choose-question", _form);
    this.dialogVisibleFrom = false;
    this.$emit("close");
    
    // this.$refs.questionForm.validate((valid) => {
    //   console.log("进来验证")
    //   if (valid) {
    // this.$emit("choose-question", this.questionForm);
    // this.closeDialog()
    //   } else {
    //     console.log('error submit!!');
    //     return false;
    //   }
    // });
  },
  //关闭弹窗
  closeDialog() {
    if(this.isEdit){
      let _form = this.queForm
      this.$emit("choose-question", _form);
    }else{
      console.log("直接关闭")
    }
    this.dialogVisibleFrom = false;
    this.$emit("close");
   
  },
},
};
</script>

<style scoped lang="scss">
.questionDialog{
min-width: 1200px;
.delectOption{
  margin: 8px 15px;
  color: #364ECF;
  cursor: pointer;
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 87px;
}

.uploadBox {
  /deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
/deep/.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
/deep/.el-upload-list__item {
  width: 80px;
  height: 80px;
}
display: flex;
&-desc {
  font-size: 12px;
  color: #999;
  padding: 8px 0 8px 15px;
  > p {
    line-height: 20px;
  }
}
}
.addBtn {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  width: 132px;
  height: 32px;
  display: flex;
  border-radius: 4px;
  background: rgba(38, 112, 251, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  &:hover {
    background: #2670fb;
    color: #fff;
  }
}
/deep/.el-dialog--center .el-dialog__footer{
  text-align: center;
}
}
</style>